exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".attention {\n  color: #e3342f;\n  font-size: 1rem;\n}\ninput[type=number] {\n  -moz-appearance: textfield;\n}\ninput[type=number]::-webkit-outer-spin-button,\ninput[type=number]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n}\n.zip-error-text {\n  margin-top: -10px;\n  font-size: 1.05rem;\n}\n.zerror > .v-input__control > .v-input__slot:before {\n  border-color: #ff5252 !important;\n}", ""]);

// exports
